Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../../styles");
var _styles2 = require("../../../components/Heading/styles");
var useStyles = exports.useStyles = function useStyles() {
  var _headingUseStyles = (0, _styles2.useStyles)(),
    headingStyles = _headingUseStyles.styles;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    container = _STYLES$useStyles.container,
    fontSemiBold = _STYLES$useStyles.fontSemiBold,
    fontSize = _STYLES$useStyles.fontSize,
    lineHeight = _STYLES$useStyles.lineHeight,
    spacing = _STYLES$useStyles.spacing,
    grid = _STYLES$useStyles.grid,
    fontRegular = _STYLES$useStyles.fontRegular,
    fontBold = _STYLES$useStyles.fontBold;
  var styles = _reactNative.StyleSheet.create({
    container: container,
    heading: {
      textAlign: 'center',
      marginBottom: spacing.l,
      maxWidth: grid.maxTextWidth,
      alignSelf: 'center',
      fontSize: headingStyles.h2.fontSize,
      lineHeight: headingStyles.h2.lineHeight
    },
    intro: Object.assign({}, fontSemiBold, {
      color: colors.brand,
      textAlign: 'center',
      fontSize: fontSize.m,
      lineHeight: lineHeight.m,
      maxWidth: grid.maxColumnWidth,
      alignSelf: 'center'
    }),
    section: {
      marginBottom: spacing.xxxl
    },
    cta: {
      marginTop: spacing.normal,
      alignSelf: 'center'
    },
    rankTabs: {
      marginBottom: spacing.xxxxl
    },
    shareTitle: Object.assign({}, fontBold, {
      color: colors.brand,
      fontSize: fontSize.m,
      lineHeight: lineHeight.m,
      textAlign: 'center',
      maxWidth: grid.maxTextWidth,
      alignSelf: 'center',
      marginBottom: spacing.normal
    }),
    shareText: Object.assign({}, fontRegular, {
      color: colors.brand,
      fontSize: fontSize.m,
      lineHeight: lineHeight.m,
      textAlign: 'center',
      maxWidth: grid.maxTextWidth,
      alignSelf: 'center',
      marginBottom: spacing.normal
    })
  });
  return {
    styles: styles
  };
};